(ns ycweb.app.website.dlp.widgets.matrix3column
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.website.cards :as cards]
   [ycweb.util.core :as u]))

(rum/defc matrix-3-column < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:matrix-3-column/keys [categories on-page-link-id]} properties]

    [:div.yc-section
     {:id (when (trf/toboolean on-page-link-id) on-page-link-id)}

     (when (u/presence categories)
       [:div
        {:class (u/bem :flex-grid-group [:align-left])}
        (map
          (fn [category]
            [:div
             {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-4])}
             (cards/category-card app-atom category)])
          categories)])]))
